<ng-container *ngIf="tableData">
    <div class="mt-3" [ngClass]="{ 'card-panel': tableData.infoTableSectionTitle }">
        <div class="p-3" *ngIf="tableData.infoTableSectionTitle">
            <app-section-title
                [sectionTitleConfig]="tableData.infoTableSectionTitle"
            ></app-section-title>
        </div>
        <div
            *ngFor="let infoTableData of tableData.infoTableData"
            [ngClass]="{
                'pb-4 px-3 px-lg-5 ': tableData.infoTableSectionTitle
            }"
        >
            <h4 >{{ infoTableData.cardHeader }}</h4>
            <div
                class="card-panel"
                [ngStyle]="{
                    'background-color':
                        tableData.infoTableBackground.backgroundColor
                }"
            >
                <div class="card-body">
                    <div
                        class="table-responsive"
                        *ngFor="
                            let header of infoTableData.headers;
                            let i = index
                        "
                    >
                        <table class="table table-striped info-table">
                            <thead>
                                <tr>
                                  <ng-container
                                    *ngFor="let headerKey of header| keyvalue: originalOrder
                                        ">
                                    <th
                                      *ngIf="headerKey.value.type === undefined || headerKey.value.type !== 'NOT_SHOWN'"
                                        scope="col"
                                    >
                                      <span [ngSwitch]="headerKey.value.type">
                                          <ng-container *ngSwitchCase="'PLAIN_TEXT'">
                                            {{ headerKey.value.value }}
                                          </ng-container>
                                          <ng-container *ngSwitchDefault>
                                              {{ headerKey.value }}
                                          </ng-container>
                                      </span>
                                    </th>
                                  </ng-container>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let rows of infoTableData.data; let i = index"
                                    [ngStyle]="{
                                        'background-color':
                                            tableData.infoTableBackground
                                                .rowColor
                                    }"
                                >
                                  <ng-container
                                    *ngFor="
                                            let rowKey of infoTableData.data[i]
                                                | keyvalue: originalOrder
                                        ">
<!--                                    <td *ngIf="rowKey.value !== undefined; else multiValue">-->
<!--                                        <span>-->
<!--                                            {{ rowKey.value }}-->
<!--                                        </span>-->
<!--                                    </td>-->


                                    <td *ngIf="(rowKey.value === undefined  || rowKey.value === null || rowKey.value.type === undefined); else multiValue">
                                        <span>
                                            {{ rowKey.value }}
                                        </span>
                                    </td>
                                    <ng-template #multiValue>
                                      <td *ngIf="rowKey.value.type !== 'NOT_SHOWN'">
                                        <span [ngSwitch]="rowKey.value.type">
                                            <ng-container *ngSwitchCase="'ACTION'">
                                                <div
                                                  class="
                                                        d-flex
                                                        align-items-center
                                                    "
                                                >
                                                    <div
                                                      *ngFor="
                                                            let buttonConfig of rowKey.value.value
                                                        "
                                                      class="app-button-wrapper"
                                                    >
                                                        <app-button
                                                          [label]="buttonConfig.label"
                                                          [hint]="buttonConfig.hint"
                                                          [actionCallback]="
                                                                buttonConfig.actionCallback
                                                            "
                                                          [classes]="buttonConfig.classes"

                                                          [otherProperties]="
                                                                buttonConfig.otherProperties
                                                            "
                                                          [tip]="buttonConfig.tip"
                                                        ></app-button>
                                                    </div>
                                                </div>
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'PLAIN_TEXT'">
                                              <span [innerHTML]="rowKey.value.value" style="{{rowKey.value.style}}"></span>
                                            </ng-container>
                                            <ng-container *ngSwitchDefault>
                                                <span>{{ rowKey.value }}</span>
                                            </ng-container>
                                        </span>
                                      </td>
                                    </ng-template>
                                  </ng-container>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
          </div>
    </div>
</ng-container>
